import * as React from 'react';
import { Phone } from './Phone';
import { UIHeading2 } from '@cian/ui-kit/typography';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var PhonePopupContent = function PhonePopupContent(_ref) {
  var name = _ref.name,
    workTime = _ref.workTime,
    logoUrl = _ref.logoUrl,
    type = _ref.type,
    phone = _ref.phone,
    title = _ref.title;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIHeading2, {
      children: title
    }), /*#__PURE__*/_jsx(Phone, {
      name: name,
      workTime: workTime,
      logoUrl: logoUrl,
      type: type,
      phone: phone
    })]
  });
};